import { useEffect, useMemo, useRef, useState } from 'react';

const F = "'Inter',-apple-system,sans-serif";
const D = "'Bangers','Arial Black',cursive";

const hueOf = (name) => { let h = 7; for (const ch of name || '') h = (h * 31 + ch.charCodeAt(0)) % 360; return h; };
const spineBg = (h, l = 40) => `linear-gradient(90deg, hsl(${h},52%,${l - 8}%) 0%, hsl(${h},55%,${l + 6}%) 45%, hsl(${h},52%,${l - 10}%) 100%)`;

const cleanTitle = (bd) => {
  let t = (bd.titre || '').trim();
  const s = (bd.serie || '').trim();
  if (s && t.toLowerCase().startsWith(s.toLowerCase())) t = t.slice(s.length);
  t = t.replace(/^[\s,:\-–—]+/, '').replace(/^(tome|t\.?|vol\.?)\s*\d+\s*[-–—:.]?\s*/i, '').trim();
  return t;
};

const WOOD = 'linear-gradient(#a8744a, #7d5232 55%, #5e3b22)';

const Plank = () => <div style={{ height: 12, background: WOOD, borderRadius: 3, boxShadow: '0 5px 7px rgba(0,0,0,.28)' }} />;

const ShelfRow = ({ children, minH }) => (
  <div style={{ marginBottom: 16 }}>
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 4, padding: '12px 10px 0', minHeight: minH,
      background: 'linear-gradient(rgba(0,0,0,.04), rgba(0,0,0,.16))', borderLeft: '6px solid #7d5232', borderRight: '6px solid #7d5232', borderRadius: '4px 4px 0 0' }}>
      {children}
    </div>
    <Plank />
  </div>
);

// ── un tome (tranche ou couverture) ───────────────────────────────────────────
function Book({ label, bd, count, hue, mode, jitter, hs, onClick }) {
  const cover = bd?.photos?.[0]?.url;
  const title = bd ? cleanTitle(bd) : '';
  const dup = count > 1;
  const common = { position: 'relative', flexShrink: 0, cursor: bd ? 'pointer' : 'default' };

  if (mode === 'couv') {
    const w = 64, h = 92;
    if (!bd) return (
      <div title={`${label} manquant`} style={{ ...common, width: w, height: h, border: '2px dashed rgba(140,120,100,.55)', borderRadius: 4, background: 'rgba(0,0,0,.14)', boxShadow: 'inset 0 2px 8px rgba(0,0,0,.25)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--muted)', fontFamily: F, fontSize: 12, fontWeight: 700 }}>{label}</div>
    );
    return (
      <div onClick={() => onClick(bd)} title={bd.titre || label} style={{ ...common, width: w, height: h, borderRadius: 3, overflow: 'hidden', boxShadow: '2px 3px 6px rgba(0,0,0,.4)', background: cover ? '#000' : spineBg(hue), color: '#fff' }}>
        {cover ? <img src={cover} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : (
          <div style={{ height: '100%', padding: 5, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', fontFamily: F }}>
            <div style={{ fontFamily: D, fontSize: 22, lineHeight: 1 }}>{label}</div>
            <div style={{ fontSize: 9, fontWeight: 600, lineHeight: 1.15, overflow: 'hidden', maxHeight: 40 }}>{title || bd.serie}</div>
          </div>
        )}
        {dup && <span style={{ position: 'absolute', top: 2, right: 2, background: '#F5C842', color: '#1C1612', borderRadius: 99, fontSize: 9, fontWeight: 800, padding: '1px 5px', fontFamily: F }}>×{count}</span>}
        {bd.lu && <span style={{ position: 'absolute', bottom: 2, right: 3, color: '#4ADE80', fontSize: 12, fontWeight: 800 }}>✓</span>}
      </div>
    );
  }

  const w = 30, h = 128 + jitter;
  if (!bd) return (
    <div title={`${label} manquant`} style={{ ...common, width: w, height: 128, border: '2px dashed rgba(140,120,100,.55)', borderRadius: 3, background: 'rgba(0,0,0,.16)', boxShadow: 'inset 0 2px 8px rgba(0,0,0,.3)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: 6, color: 'var(--muted)', fontFamily: F, fontSize: 11, fontWeight: 700 }}>
      <span style={{ writingMode: 'vertical-rl' }}>{label}</span>
    </div>
  );
  return (
    <div onClick={() => onClick(bd)} title={bd.titre || label}
      style={{ ...common, width: w, height: h, borderRadius: '3px 3px 0 0', background: spineBg(hue, hs ? 46 : 40), color: '#fff', boxShadow: '2px 0 5px rgba(0,0,0,.35), inset 0 0 0 1px rgba(255,255,255,.08)', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5px 0', fontFamily: F, overflow: 'hidden' }}>
      <div style={{ height: 3, width: '70%', background: 'rgba(255,255,255,.35)', borderRadius: 2, marginBottom: 4 }} />
      <div style={{ fontFamily: D, fontSize: 17, lineHeight: 1, letterSpacing: '.02em' }}>{label}</div>
      <div style={{ flex: 1, minHeight: 0, marginTop: 5, writingMode: 'vertical-rl', transform: 'rotate(180deg)', fontSize: 10, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', opacity: .92 }}>{title || bd.serie}</div>
      <div style={{ height: 3, width: '70%', background: 'rgba(255,255,255,.3)', borderRadius: 2, marginTop: 4 }} />
      {dup && <span style={{ position: 'absolute', top: 26, right: 1, background: '#F5C842', color: '#1C1612', borderRadius: 99, fontSize: 8, fontWeight: 800, padding: '0 3px' }}>×{count}</span>}
      {bd.lu && <span style={{ position: 'absolute', bottom: 12, left: 2, color: '#4ADE80', fontSize: 11, fontWeight: 800 }}>✓</span>}
    </div>
  );
}

export default function ShelfModal({ serie: initialSerie, allBds, totals = {}, hsTotals = {}, onClose, onEditBD }) {
  const [serie, setSerie] = useState(initialSerie);
  const scrollRef = useRef(null);
  const bds = useMemo(() => allBds.filter((b) => (b.serie?.trim() || '— Sans série —') === serie), [allBds, serie]);
  const total = totals[serie] || null;
  const hsTotal = hsTotals[serie] || null;
  const [mode, setMode] = useState(() => { try { return localStorage.getItem('bulletheque_shelf_mode') || 'tranche'; } catch { return 'tranche'; } });
  const setM = (m) => { setMode(m); try { localStorage.setItem('bulletheque_shelf_mode', m); } catch {} };
  const boxRef = useRef(null);
  const [width, setWidth] = useState(360);

  useEffect(() => {
    const measure = () => setWidth(boxRef.current?.clientWidth || window.innerWidth);
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, []);

  const hue = hueOf(serie);
  const { slots, extras, ownedNums, missingCount } = useMemo(() => {
    const byNum = new Map(); const ex = [];
    bds.forEach((b) => {
      const n = parseInt(b.numero, 10);
      if (!isNaN(n) && n > 0) { if (!byNum.has(n)) byNum.set(n, []); byNum.get(n).push(b); } else ex.push(b);
    });
    const max = total || (byNum.size ? Math.max(...byNum.keys()) : 0);
    const sl = [];
    for (let n = 1; n <= max; n++) sl.push({ n, items: byNum.get(n) || [] });
    // numéros au-dessus du total (si le total saisi est trop petit)
    [...byNum.keys()].filter((n) => n > max).sort((a, b) => a - b).forEach((n) => sl.push({ n, items: byNum.get(n) }));
    ex.sort((a, b) => (a.titre || '').localeCompare(b.titre || '', 'fr'));
    return { slots: sl, extras: ex, ownedNums: byNum.size, missingCount: sl.filter((s) => !s.items.length).length };
  }, [bds, total]);

  const itemW = (mode === 'couv' ? 64 : 30) + 4;
  const avail = Math.max(120, width - 32 - 12 - 20);
  const perRow = Math.max(1, Math.floor(avail / itemW));
  const chunk = (arr) => { const out = []; for (let i = 0; i < arr.length; i += perRow) out.push(arr.slice(i, i + perRow)); return out; };
  const minH = mode === 'couv' ? 100 : 150;

  const hsMissing = hsTotal ? Math.max(0, hsTotal - extras.length) : 0;
  const hsItems = [
    ...extras.map((b, i) => ({ key: 'e' + b.id, label: 'HS', bd: b, jit: (i * 5) % 12 })),
    ...Array.from({ length: hsMissing }, (_, i) => ({ key: 'm' + i, label: 'HS', bd: null, jit: 0 })),
  ];

  // Reste de la collection : une étagère par série, avec son nom
  const groups = useMemo(() => {
    const g = {};
    allBds.forEach((b) => { const k = b.serie?.trim() || '— Sans série —'; (g[k] = g[k] || []).push(b); });
    return Object.keys(g).sort((a, b) => a.localeCompare(b, 'fr')).map((name) => ({
      name,
      items: g[name].slice().sort((a, b) => (parseInt(a.numero, 10) || 0) - (parseInt(b.numero, 10) || 0)),
    }));
  }, [allBds]);
  const miniPerRow = Math.max(4, Math.floor(Math.max(120, width - 32 - 12 - 20) / 11));
  const pick = (name) => { setSerie(name); scrollRef.current?.scrollTo({ top: 0, behavior: 'smooth' }); };

  return (
    <div ref={scrollRef} style={{ position: 'fixed', inset: 0, zIndex: 500, background: 'var(--bg)', overflowY: 'auto', fontFamily: F, color: 'var(--ink)' }}>
      <div style={{ position: 'sticky', top: 0, zIndex: 5, background: 'var(--header-bg)', backdropFilter: 'blur(14px)', WebkitBackdropFilter: 'blur(14px)', borderBottom: '1px solid var(--border)', padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontFamily: D, fontSize: '1.4rem', letterSpacing: '.04em', color: 'var(--orange)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>🗄️ {serie}</div>
          <div style={{ fontSize: 12.5, color: 'var(--muted)', fontWeight: 600 }}>
            {ownedNums}{total ? ` / ${total}` : ''} tome{ownedNums > 1 ? 's' : ''}
            {extras.length > 0 && ` · ${extras.length}${hsTotal ? ` / ${hsTotal}` : ''} hors-série${extras.length > 1 ? 's' : ''}`}
            {missingCount > 0 && ` · ${missingCount} manquant${missingCount > 1 ? 's' : ''}`}
          </div>
        </div>
        <button onClick={onClose} aria-label="Fermer" style={{ width: 38, height: 38, borderRadius: '50%', border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--muted)', fontSize: 20, cursor: 'pointer' }}>×</button>
      </div>

      <div ref={boxRef} style={{ maxWidth: 760, margin: '0 auto', padding: '14px 16px 40px' }}>
        <div style={{ display: 'flex', gap: 4, background: 'var(--surface2)', borderRadius: 12, padding: 4, border: '1px solid var(--border)', marginBottom: 16 }}>
          {[['tranche', '📚 Tranches'], ['couv', '🖼️ Couvertures']].map(([id, lab]) => (
            <button key={id} onClick={() => setM(id)} style={{ flex: 1, padding: '9px 4px', border: 'none', borderRadius: 9, cursor: 'pointer', fontFamily: F, fontSize: 13, fontWeight: 700, background: mode === id ? 'var(--surface)' : 'transparent', color: mode === id ? 'var(--orange)' : 'var(--muted)', boxShadow: mode === id ? 'var(--card-shadow)' : 'none' }}>{lab}</button>
          ))}
        </div>

        {slots.length === 0 && extras.length === 0 ? (
          <div style={{ textAlign: 'center', color: 'var(--muted)', padding: '2rem 0' }}>Aucun album dans cette série.</div>
        ) : (
          <>
            {slots.length > 0 && chunk(slots).map((row, ri) => (
              <ShelfRow key={ri} minH={minH}>
                {row.map((s) => <Book key={s.n} label={String(s.n)} bd={s.items[0]} count={s.items.length} hue={hue} mode={mode} jitter={(s.n * 7) % 14} onClick={onEditBD} />)}
              </ShelfRow>
            ))}

            {hsItems.length > 0 && (
              <>
                <div style={{ fontSize: 12, fontWeight: 800, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.06em', margin: '6px 2px 10px' }}>
                  Hors-séries{hsTotal ? ` · ${extras.length} sur ${hsTotal}` : ''}
                </div>
                {chunk(hsItems).map((row, ri) => (
                  <ShelfRow key={'h' + ri} minH={minH}>
                    {row.map((s) => <Book key={s.key} label={s.label} bd={s.bd} count={1} hue={(hue + 40) % 360} hs mode={mode} jitter={s.jit} onClick={onEditBD} />)}
                  </ShelfRow>
                ))}
              </>
            )}
            {extras.length > 0 && !hsTotal && (
              <div style={{ fontSize: 12, color: 'var(--muted)', margin: '-6px 2px 14px' }}>
                Astuce : indique le nombre total de hors-séries de cette série (dans l'onglet Séries) pour voir les emplacements manquants.
              </div>
            )}
          </>
        )}

        <div style={{ fontFamily: D, fontSize: '1.25rem', letterSpacing: '.04em', color: 'var(--muted)', margin: '26px 0 4px' }}>Toute ma collection</div>
        <div style={{ fontSize: 12.5, color: 'var(--muted)', marginBottom: 12 }}>Touche une série pour l'afficher en grand.</div>
        {groups.map(({ name, items }) => {
          const sel = name === serie;
          const rows = [];
          for (let i = 0; i < items.length; i += miniPerRow) rows.push(items.slice(i, i + miniPerRow));
          return (
            <button key={name} onClick={() => pick(name)} aria-label={`Afficher ${name}`}
              style={{ display: 'block', width: '100%', textAlign: 'left', border: 'none', background: 'transparent', padding: 0, margin: '0 0 14px', cursor: 'pointer', fontFamily: F, opacity: sel ? 1 : .8 }}>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, margin: '0 2px 5px' }}>
                <span style={{ width: 10, height: 10, borderRadius: 3, background: spineBg(hueOf(name), 42), flexShrink: 0, alignSelf: 'center' }} />
                <span style={{ fontSize: 14, fontWeight: 800, color: sel ? 'var(--orange)' : 'var(--ink)' }}>{name}</span>
                <span style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 600 }}>{items.length} album{items.length > 1 ? 's' : ''}{sel ? ' · affichée' : ''}</span>
              </div>
              {rows.map((row, ri) => (
                <div key={ri} style={{ marginBottom: ri === rows.length - 1 ? 0 : 6 }}>
                  <div style={{ display: 'flex', alignItems: 'flex-end', gap: 2, padding: '8px 10px 0', minHeight: 62, background: 'linear-gradient(rgba(0,0,0,.04), rgba(0,0,0,.14))', borderLeft: '6px solid #7d5232', borderRight: '6px solid #7d5232', borderRadius: '4px 4px 0 0', outline: sel ? '2px solid var(--orange)' : 'none', outlineOffset: 1 }}>
                    {row.map((b, i) => (
                      <div key={b.id} title={b.titre || name} style={{ width: 9, height: 42 + (((b.numero | 0) * 7 + i * 3) % 14), flexShrink: 0, borderRadius: '2px 2px 0 0', background: spineBg(hueOf(name), 42) }} />
                    ))}
                  </div>
                  <div style={{ height: 8, background: WOOD, borderRadius: 3, boxShadow: '0 3px 5px rgba(0,0,0,.25)' }} />
                </div>
              ))}
            </button>
          );
        })}
      </div>
    </div>
  );
}
